import { mdiMonitor, mdiMonitorShimmer } from "@mdi/js";
import React, { Suspense } from "react";
import { Button as ReactButton } from "react-bootstrap";
import { addStyle } from "react-bootstrap/lib/utils/bootstrapUtils";
import { useDispatch, useSelector } from "react-redux";
import { setUseModernLayout } from "../actions/window";
import { MainProvider, MenuLayerProvider, PagesProvider, WindowProvider, } from "../contexts";
import Spinner from "../controls/Spinner";
import { Button } from "../ui/components/button/Button";
import { MutexProvider } from "../util/MutexContext";
import { ClassicLayout, ModernLayout } from "./layout";
addStyle(ReactButton, "secondary");
addStyle(ReactButton, "ad");
addStyle(ReactButton, "ghost");
addStyle(ReactButton, "link");
addStyle(ReactButton, "inverted");
const LayoutSwitcher = () => {
    if (process.env.NODE_ENV !== "development") {
        return null;
    }
    const dispatch = useDispatch();
    const useModernLayout = useSelector((state) => state.settings.window.useModernLayout);
    return (React.createElement(Button, { buttonType: "primary", className: "fixed right-4 bottom-4 z-toast", leftIconPath: useModernLayout ? mdiMonitor : mdiMonitorShimmer, size: "sm", title: useModernLayout ? "Switch to Classic" : "Switch to Modern", onClick: () => dispatch(setUseModernLayout(!useModernLayout)) }));
};
export const AppLayout = () => {
    const useModernLayout = useSelector((state) => state.settings.window.useModernLayout);
    return (React.createElement(Suspense, { fallback: React.createElement(Spinner, { className: "suspense-spinner" }) },
        React.createElement(WindowProvider, null,
            React.createElement(MenuLayerProvider, null,
                React.createElement(MainProvider, null,
                    React.createElement(PagesProvider, null,
                        React.createElement(MutexProvider, null, useModernLayout ? React.createElement(ModernLayout, null) : React.createElement(ClassicLayout, null)),
                        React.createElement(LayoutSwitcher, null)))))));
};
